export default {
  setSettlementList(state, payload) {
    state.settlementSheet = payload
  },
  concatSettlementList(state, payload) {
    state.settlementSheet = state.settlementSheet.concat(payload)
  },
}
